import api from './api';

export interface ObjectiveContainer {
  id: number;
  title: string;
  description?: string;
  parent: number | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
  weight: number;
  children_count: number;
  objectives_count: number;
}

class ObjectiveContainerService {
  async getContainers(parentId: number | null = null): Promise<ObjectiveContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/objective-containers/', { params });
    // Handle paginated response
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<ObjectiveContainer> {
    const response = await api.get(`/objective-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(id: number): Promise<{ containers: ObjectiveContainer[], objectives: any[] }> {
    const response = await api.get(`/objective-containers/${id}/contents/`);
    return response.data;
  }

  async createContainer(data: Partial<ObjectiveContainer>): Promise<ObjectiveContainer> {
    const response = await api.post('/objective-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<ObjectiveContainer>): Promise<ObjectiveContainer> {
    const response = await api.patch(`/objective-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/objective-containers/${id}/`);
  }

  async reorderContainers(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/objective-containers/reorder/', { items });
  }
}

const objectiveContainerService = new ObjectiveContainerService();
export default objectiveContainerService;
